interface IUserTypeSource {
	/** What the login response calls the account type. */
	userType?: string;
	/** What older cached sessions call it. */
	type?: string;
}

/** The account type as a display label, e.g. "Owner". The server sends it as `userType`; older cached sessions have `type`. */
export function getUserTypeLabel(user: IUserTypeSource | null | undefined) {
	const userType = user?.userType ?? user?.type;
	return userType ? userType.charAt(0).toUpperCase() + userType.slice(1) : '';
}
